import React, { useState, useRef, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Button, Form, Input } from "semantic-ui-react";
import TextEditor from "../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";

import { Container, Content, Title, Image } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Dropzone from "../../../../components/Admin/Dropzone";
import { isAuthAdmin } from "../../../../services/auth";
import { systemLogs } from "../../../../services/system_logs";

const EditarConsultor = (props) => {
  const id = props.match.params.id;
  const [selectedFileFoto, setSelectedFileFoto] = useState("");
  const [selectedFileAssin, setSelectedFileAssin] = useState("");
  const [fotoUrl, setFotoUrl] = useState("");
  const [valorCheck, setValorCheck] = useState(false);
  const description = useRef("");
  const [consultor, setConsultor] = useState({});
  const [assinaturaUrl, setAssinaturaUrl] = useState("");

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadConsultor = async () => {
    try {
      const res = await api.get(`/consultor/${id}`);
      await systemLogs("consultor", `listou o consultor de id=${id}`);

      const newConsultor = res.data;
      const newAssinaturaUrl = newConsultor.assinatura;
      const newFotoUrl = newConsultor.imagem;

      setAssinaturaUrl(newAssinaturaUrl);
      setFotoUrl(newFotoUrl);
      setConsultor(newConsultor);
    } catch (err) {
      swal("Erro", "Consultor não cadastrado no sistema !", "error").then(
        (res) => {
          props.history.push("/admin/consultores");
        }
      );
    }
  };

  const uploadImageFoto = useCallback(async () => {
    try {
      if (!selectedFileFoto) {
        return false;
      }

      if (!consultor.nome) {
        swal("Erro !", "Por favor, insira o nome do consultor !", "error");
        return false;
      }

      setFotoUrl("");

      const inputData = new FormData();

      inputData.append("file", selectedFileFoto);
      inputData.append("path", "imagens-voitto/imagens-blog/meta/ctas");

      const response = await api.post("/upload", inputData);
      const { url } = response.data;

      setConsultor({ ...consultor, imagem: url });
      setFotoUrl(url);

      toast.success("A operação de upload da imagem do consultor foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      return true;
    } catch (err) {
      toast.error("A operação de upload da imagem do consultor falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      return false;
    }
  }, [selectedFileFoto, consultor.nome]);

  const uploadImageAssin = useCallback(async () => {
    try {
      if (!selectedFileAssin) {
        return false;
      }

      if (!consultor.nome) {
        swal("Erro !", "Por favor, insira o nome do consultor !", "error");
        return false;
      }

      setAssinaturaUrl("");

      const formDataPayload = new FormData();

      const fileName = `${consultor.nome
        .replace(" de ", " De ")
        .replace(" da ", " Da ")}`;

      formDataPayload.append("file", selectedFileAssin);
      formDataPayload.append("nome", fileName);
      formDataPayload.append("path", `ftp-files/api/images/assinaturas`);
      formDataPayload.append("name_strategy", "keep_original_name");

      const response = await api.post("/upload", formDataPayload);

      setAssinaturaUrl(response.data.url);
      setConsultor({ ...consultor, assinatura: response.data.url });

      toast.success("A operação de upload da assinatura do consultor foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      return true;
    } catch (err) {
      toast.error("A operação de upload da assinatura do consultor falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      return false;
    }
  }, [selectedFileAssin, consultor.nome]);

  const update = useCallback(async () => {
    const consultorValidation = await yup.object().shape({
      nome: yup
        .string("Necessário que informe o nome do consultor")
        .required("Necessário que informe o nome do consultor"),
      curriculo: yup
        .string("Necessário que informe o curriculo")
        .required("Necessário que informe o curriculo"),
      seg: yup
        .string("Necessário que informe o segmento")
        .required("Necessário que informe o segmento"),
      sexo: yup
        .string("Necessário que informe o sexo")
        .required("Necessário que informe o sexo"),
    });

    const assinatura = !valorCheck ? assinaturaUrl : "";

    const payload = {
      id: consultor.id,
      seg: consultor.seg,
      ativo: consultor.ativo,
      nome: consultor.nome,
      sexo: consultor.sexo,
      curriculo: description.current,
      linkedin_url: consultor.linkedin_url,
      imagem: consultor.imagem,
      video: consultor.video,
      assinatura,
    };

    try {
      await consultorValidation.validate(payload, { abortEarly: true });

      await api.put(`/admin/consultor/${id}`, payload);

      await systemLogs("consultor", `editou o consultor de id=${id}`);

      toast.success("Consultor alterado com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      props.history.push("/admin/consultores");
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }

      swal("Não foi possível salvar o consultor", err, "").then(() =>
        props.history.push("/admin/consultores")
      );
    }
  }, [consultor, description, valorCheck, assinaturaUrl]);

  useEffect(() => {
    loadAuth();
    loadConsultor();
  }, []);

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>Editar Consultor</Title>

          <Form>
            <Form.Group widths="equal">
              <label>ID:</label>
              <input type="text" disabled value={consultor.id} />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Nome:"
                placeholder="Nome do consultor..."
                value={consultor.nome}
                onChange={(e) => {
                  setConsultor({ ...consultor, nome: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Field>
                <label>Foto:</label>
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "flex-end",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <Dropzone onFileUploaded={setSelectedFileFoto} />
                  </div>
                  {consultor.nome && fotoUrl && (
                    <div
                      style={{
                        flex: "0 0 300px",
                        height: "auto",
                        minHeight: "200px",
                      }}
                    >
                      <Image
                        src={fotoUrl}
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "contain",
                          border: "2px dashed #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f8f9fa",
                          padding: "10px",
                          boxSizing: "border-box",
                        }}
                      />
                    </div>
                  )}
                </div>
              </Form.Field>
            </Form.Group>
            <Form.Field>
              <Button color="primary" onClick={() => uploadImageFoto()}>
                Subir imagem
              </Button>
            </Form.Field>
            <Form.Field>
              <label>Sexo:</label>
              <label>
                <input
                  type="radio"
                  name="sexo"
                  id="sexo"
                  checked={consultor.sexo == "M" ? true : false}
                  onClick={(e) => setConsultor({ ...consultor, sexo: "M" })}
                />
                masculino
              </label>
              <label>
                <input
                  type="radio"
                  name="sexo"
                  id="sexo"
                  checked={consultor.sexo == "F" ? true : false}
                  onClick={(e) => setConsultor({ ...consultor, sexo: "F" })}
                />
                feminino
              </label>
            </Form.Field>

            <label>Curriculo</label>
            <TextEditor
              haveFullscreen
              default={consultor.curriculo}
              text={description}
            />
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Video:"
                placeholder="Video..."
                value={consultor.video}
                onChange={(e) => {
                  setConsultor({ ...consultor, video: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Linkedin:"
                placeholder="Linkedin link..."
                value={consultor.linkedin_url}
                onChange={(e) => {
                  setConsultor({ ...consultor, linkedin_url: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Field>
                <label>Assinatura:</label>
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "flex-end",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <Dropzone onFileUploaded={setSelectedFileAssin} />
                  </div>
                  {consultor.nome && assinaturaUrl && (
                    <div
                      style={{
                        flex: "0 0 300px",
                        height: "auto",
                        minHeight: "200px",
                      }}
                    >
                      <Image
                        src={assinaturaUrl}
                        onError={(e) => {
                          if (e.target.src.includes(".jpg")) {
                            setAssinaturaUrl(
                              e.target.src.replace(".jpg", ".png")
                            );
                          }
                        }}
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "contain",
                          border: "2px dashed #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f8f9fa",
                          padding: "10px",
                          boxSizing: "border-box",
                        }}
                      />
                    </div>
                  )}
                </div>
                <label style={{ marginTop: "10px" }}>
                  <input
                    type="checkbox"
                    checked={valorCheck}
                    onChange={(e) => setValorCheck(e.target.checked)}
                  />
                  Remover assinatura
                </label>
              </Form.Field>
            </Form.Group>
            <Form.Field>
              <Button color="primary" onClick={() => uploadImageAssin()}>
                Subir assinatura
              </Button>
            </Form.Field>
            <Form.Group>
              <Form.Field control={Button} onClick={() => update()}>
                Salvar
              </Form.Field>
              <Link to="/admin/consultores">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(EditarConsultor);